import { useState } from 'react';
import clsx from 'clsx';
import { Collapse } from '@mui/material';
import { __ } from '../../shared/tools';

import SearchIcon from '../../assets/icons/search';
import ArrowIcon from '../../assets/icons/arrow_right';

import style from './style.module.scss';

export const SearchWidget = ({ open, searchQuery, homeUrl, ...props }) => {
    const [searchText, setSearchText] = useState(searchQuery);

    return (
        <Collapse in={open}>
            <div className={clsx(style.widget, open && style.open, props.className)}>
                <form method="get" role="search" action={homeUrl} className={style.form}>
                    <SearchIcon />
                    <input
                        type="search"
                        name="s"
                        placeholder={__('Rechercher')}
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                    />
                    <button type="submit" className={style.arrow}>
                        <ArrowIcon />
                    </button>
                </form>
            </div>
        </Collapse>
    );
};
